module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAdCAYAAADCdc79AAABS0lEQVRYR+1X7U3DUAy8mwA2gA3oCN2AjgATkE7QMgHtBt2AZgQmIJ2AdgOY4NAVV4qioIigvL5KeX/y8RT74nf22ZQ0A7AAMMHP2gKYk9z7QdIGwD2A69gf6mJ/c0ryzU3Dy5pkEWBfh0LQYndvQGrZeCM5lbSM6CXD9BugkuRMUgHgJRkaAAZkzpgj9fVIciPpFsBHQkClAdmpI2FSfwaptyR9b1L7vYk/9Dr65tBe/mp/BNQVsTFCnRGKLHoC4GzzqgA817LMGdgsC112++xbMdZOewO4a1iwlq0C7Hsf6z2/qS5GOs6qZTkd2c5HNg3pMHG/QjqWtX7IpE4hHSb1aqxDXdk3RujyIhQNWn2qqEiWpz+Jap1COtygHTvG7FrYtqnjrE1+dmNQToPiwRx6AOCB8DS97iwVjVHa0nHVlbL/3LffIrvC+A3PZbTQriww9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/course/icon-5.png
// module id = p7/I
// module chunks = 96